module.exports = __webpack_public_path__ + "img/searchPlus.03dcdb45.svg";